var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.classes},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('ul',[(_vm.hasHeader)?[(!_vm.stickyHeader)?_c('li',{staticClass:"header"},[_vm._t("header")],2):_vm._e()]:_vm._e(),_vm._t("default"),(_vm.hasFooter)?_c('li',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }